
























import Vue, { PropType } from "vue";

// Model
import { InstallationSmartLockStatus } from "@/model/data/oneTimeCode/InstallationSmartLockStatus";
import { Machine } from "@/model/data/Machine";
import { SmartLockInternalState } from "@/model/data/enums/SmartLockInternalStateEnum";
import SmartLockActivationCard from "./SmartLockActivationCard.vue";
import SmartLockEnablingCard from "./SmartLockEnablingCard.vue";

export default Vue.extend({
    components: { SmartLockActivationCard, SmartLockEnablingCard },
    props: {
        installation: Object as PropType<InstallationSmartLockStatus>,
        machine: Object as PropType<Machine>,
        loading: Boolean,
    },
    data() {
        return {
            SmartLockInternalState,
            localInstallation: null,
        };
    },
    computed: {
        machineSmartLock() {
            if (this.localInstallation && this.localInstallation.smartLocks && this.localInstallation.smartLocks.get(this.machine.serialNumber))
                return this.localInstallation.smartLocks.get(this.machine.serialNumber);
            return null;
        },
    },
    watch: {
        installation: {
            handler(newVal) {
                this.localInstallation = newVal;
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        activated(newLocalInstallation: InstallationSmartLockStatus) {
            this.localInstallation = newLocalInstallation;
            this.$emit("data-reload");
        },
    },
});
